<script setup lang="ts">
import { convertYearMonthToInput } from "@/core/helpers/convertDate";
import { computed, defineEmits, defineProps } from "vue";
import setup from "../setupComposable/setup";
import commonProps from "../props/commonProps";

const props = defineProps(commonProps);
const emit = defineEmits(["update:modelValue"]);
const { onInput } = setup(emit);

const inputValue = computed(() => {
  if (props.type === "month") {
    return convertYearMonthToInput(props.modelValue);
  }

  return props.modelValue;
});

// Abre o seletor de mês ao clicar em qualquer parte do campo
const abrirSeletor = (event: Event) => {
  if (props.type !== "month") return;

  const input = event.target as HTMLInputElement & { showPicker?: () => void };
  try {
    input.showPicker?.();
  } catch {
    // navegador sem suporte: mantém o comportamento padrão
  }
};
</script>

<template>
  <div>
    <label v-if="$attrs.label" :class="{ required: $attrs.required }">
      {{ $attrs.label }}
    </label>
    <input
      class="form-control"
      :type="type"
      :value="inputValue"
      v-bind="$attrs"
      @input="onInput"
      @click="abrirSeletor"
    />
  </div>
</template>
